import ReactPlayer from 'react-player'
import { useState, useEffect, useRef } from "react";

import MyNavbar from "../../components/UI/MyNavbar";
import Duration from '../../components/UI/Duration'

import playIcon from "../../images/play.png";
import stopIcon from "../../images/stop.png";
import audioUrl from "../../audio/audio.mp3";

const AudioPanel = (props) => {

  const [played, setPlayed] = useState(0);
  const [playing, setPlaying] = useState(true);
  const [duration, setDuration] = useState(0);
  const [currentTimeInterval, setCurrentTimeInterval] = useState(null);

  const audioRef = useRef(null)

  useEffect(() => {
    // Get duration of the song and set it as max slider value
    audioRef.current.play();
    audioRef.current.onloadedmetadata = function () {
      setDuration(audioRef.current.duration);
    }.bind(this);

    // Sync slider position with song current time
    audioRef.current.onplay = () => {
      setPlaying(true);
      setCurrentTimeInterval(
        setInterval(() => {
          try {
            if (audioRef) {
              let seek = audioRef.current.currentTime / audioRef.current.duration;
              if (seek < 0) {
                seek = 0;
              }
              if (seek > 1) {
                seek = 1;
              }
              setPlayed(seek);
            }
          } catch (e) {
            clearInterval(currentTimeInterval);
          }
        }, 500)
      );
    };

    audioRef.current.onpause = () => {
      clearInterval(currentTimeInterval);
    };

    return () => {
      setPlayed(0);
      clearInterval(currentTimeInterval);
    }
  }, [audioRef, currentTimeInterval]);

  const togglePlay = (e) => {
    if (playing) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setPlaying(!playing);
  };

  const handleSeekChange = e => {
    let seek = e.clientX / e.currentTarget.offsetWidth; // how to get sec?
    if (seek < 0) {
      seek = 0;
    }
    if (seek > 1) {
      seek = 1;
    }
    setPlayed(seek);
    audioRef.current.currentTime = seek * audioRef.current.duration;
  }

  return (
    <div
      style={{
        height: '100vh',
        background: 'black',
        overflow: 'hidden'
      }}
    >
      <div
        style={{
          maxHeight: '75vh',
          margin: 20,
          // display: (played === 0 || played === 1) ? "none" : "block"
        }}
      >
        <ReactPlayer
          url='videos/audio.mp4'
          style={{ maxHeight: '75vh' }}
          width='100%'
          height='75vh'
          controls={false}
          loop={true}
          playing={playing}
          muted={true}
        />
        {/* play bar */}
        <div style={{
          textAlign: 'center'
        }}>
          <div
            style={{
              textAlign: 'center',
              margin: '0px auto',
              paddingTop: 10,
              width: "100%"
            }}
            onClick={handleSeekChange}
          >
            <progress
              min={0}
              max={1}
              value={played}
              step='any'
              style={{
                width: "100%"
              }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: '',
              textAlign: 'center',
              margin: '10px auto',
              width: "100%",
              justifyContent: 'space-between'
            }}
          >
            <span>
              <font
                style={{
                  borderRadius: 0,
                  margin: "auto",
                  color: 'white',
                  fontSize: 15
                }}
              >
                <Duration seconds={duration * played}
                />
              </font>
            </span>
            <span>
              <img
                src={playing ? stopIcon : playIcon}
                width={"25%"}
                height={"auto"}
                fit="cover"
                style={{
                  borderRadius: 0,
                  margin: "0px auto 0px auto",
                  padding: 0,
                }}
                onClick={e => togglePlay(e)}
              />
            </span>
            <span>
              <font
                style={{
                  borderRadius: 0,
                  margin: "auto",
                  color: 'white',
                  fontSize: 15
                }}
              >
                <Duration seconds={duration} />
              </font>
            </span>
          </div>
        </div>
        <audio autoPlay loop ref={audioRef}>
          <source src={audioUrl}></source>
        </audio>
      </div>

    </div>
  );
};

export default AudioPanel;
